import { apiSlice } from '../../api/apiSlice';

export const assignApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    assignStudents: builder.mutation({
      query: (options) => ({
        url: 'Assignment/AssignStudents',
        method: 'POST',
        credentials: 'include',
        body: options
      })
    }),
    getParentFolders: builder.mutation({
      query: () => ({
        url: 'Folder/GetParentFolders',
        method: 'GET',
        credentials: 'include'
      })
    }),
    exportXmlAssignments: builder.mutation({
      query: (options) => ({
        url: 'Assignment/ExportAssignmentToXml',
        method: 'POST',
        credentials: 'include',
        body: options
      })
    }),
    getAssignmentShareUsers: builder.mutation({
      query: (options) => ({
        url: 'Student/GetAssignmentShareUsers',
        method: 'GET',
        credentials: 'include',
        params: {
          searchString: options.searchText
        }
      })
    }),
    getCollaboratorsByAssignment: builder.mutation({
      query: (options) => ({
        url: `Assignment/${options.assignmentId}/GetSharedUsers`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    shareAssignments: builder.mutation({
      query: (options) => {
        const { assignmentIds, memberIds } = options;
        let url = 'Assignment/ShareAssignments?';
        if (assignmentIds && assignmentIds.length > 0) {
          assignmentIds.forEach((assignmentId, index) => {
            url += `assignmentIds=${assignmentId}${assignmentIds.length !== index ? '&' : ''}`;
          });
        }
        if (memberIds && memberIds.length > 0) {
          memberIds.forEach((memberId, index) => {
            url += `memberIds=${memberId}${memberIds.length !== index ? '&' : ''}`;
          });
        }
        return {
          url: url,
          method: 'POST',
          credentials: 'include'
        };
      }
    }),
    getCoTeachersByAssignment: builder.mutation({
      query: (options) => {
        const { assignmentIds } = options;
        let url = 'Assignment/GetCoTeachersById?';
        if (assignmentIds && assignmentIds.length > 0) {
          assignmentIds.forEach((assignmentId, index) => {
            url += `assignmentIds=${assignmentId}${assignmentIds.length !== index ? '&' : ''}`;
          });
        }
        return {
          url: url,
          method: 'GET',
          credentials: 'include'
        };
      }
    }),
    checkIsSelfAssigned: builder.mutation({
      query: (options) => {
        const { assignmentIds } = options;
        let url = 'Assignment/CheckIsSelfAssigned?';
        if (assignmentIds && assignmentIds.length > 0) {
          assignmentIds.forEach((assignmentId, index) => {
            url += `assignmentIds=${assignmentId}${assignmentIds.length !== index ? '&' : ''}`;
          });
        }
        return {
          url: url,
          method: 'GET',
          credentials: 'include'
        };
      }
    }),
    validateAssignmentName: builder.mutation({
      query: (options) => ({
        url: 'Assignment/ValidateAssignmentName',
        method: 'GET',
        credentials: 'include',
        params: {
          assignmentId: options.assignmentId,
          publicAssignmentName: options.publicAssignmentName,
          options: options.options
        }
      })
    }),
    searchMembers: builder.mutation({
      query: (options) => ({
        url: 'Student/SearchMembers',
        method: 'GET',
        credentials: 'include',
        params: {
          searchText: options.searchText
        }
      })
    }),
    validateSubmitAssignment: builder.mutation({
      query: (options) => ({
        url: 'Assignment/ValidateSubmitAssignment',
        method: 'GET',
        credentials: 'include',
        params: {
          assignmentId: options.assignmentId
        }
      })
    }),
    getChangeReport: builder.mutation({
      query: (options) => ({
        url: `Assignment/GetChangeReport/${options.assignmentId}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getQuestionById: builder.mutation({
      query: (options) => ({
        url: `Question/${options.questionId}/Assignment/${options.assignmentId}/DetailsById`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getPrintSettings: builder.mutation({
      query: (options) => ({
        url: 'Assignment/GetPrintSettings',
        method: 'GET',
        credentials: 'include',
        params: {
          assignmentId: options.assignmentId
        }
      })
    }),
    printQuestions: builder.mutation({
      query: (options) => ({
        url: `Assignment/${options.assignmentId}/PrintQuestions`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAnswerKey: builder.mutation({
      query: (options) => ({
        url: `Assignment/${options.assignmentId}/GetAnswerKey`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    showIdentificationFields: builder.mutation({
      query: (options) => ({
        url: `Student/ShowIdentificationFields?show=${options.condition}`,
        method: 'POST',
        credentials: 'include'
      })
    }),
    getFerpaStatus: builder.mutation({
      query: () => ({
        url: 'Student/GetFerpaStatus',
        method: 'GET',
        credentials: 'include'
      })
    }),
    createAssignmentLink: builder.mutation({
      query: (assignmentOptions) => ({
        url: 'Assignment/CreateAssignmentLink',
        method: 'POST',
        body: assignmentOptions
      })
    }),
    getAssignmentVocabulary: builder.mutation({
      query: (options) => ({
        url: `Assignment/${options.assignmentId}/Vocabulary`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAssignmentIsStarted: builder.mutation({
      query: (options) => ({
        url: `Assignment/${options.assignment}/CheckIsStarted`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getCollaboratorCount: builder.mutation({
      query: (options) => ({
        url: `Assignment/${options.assignmentId}/GetCollaboratorCount`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    setClassFilters: builder.mutation({
      query: (options) => ({
        url: 'Class/SetClassFilter',
        method: 'POST',
        credentials: 'include',
        body: options
      })
    }),
    isAssignmentsExist: builder.mutation({
      query: () => ({
        url: 'Assignment/UserHasAssignment',
        method: 'GET',
        credentials: 'include'
      })
    }),
    setFilterCollapse: builder.mutation({
      query: (options) => ({
        url: `Assignment/FiltersCollapseState/?isCollapsed=${options.isCollapsed}`,
        method: 'PUT',
        credentials: 'include'
      })
    })
  })
});

export const {
  useAssignStudentsMutation,
  useGetParentFoldersMutation,
  useExportXmlAssignmentsMutation,
  useGetAssignmentShareUsersMutation,
  useGetCoTeachersByAssignmentMutation,
  useGetCollaboratorsByAssignmentMutation,
  useShareAssignmentsMutation,
  useValidateAssignmentNameMutation,
  useGetPrintSettingsMutation,
  usePrintQuestionsMutation,
  useGetAnswerKeyMutation,
  useSearchMembersMutation,
  useValidateSubmitAssignmentMutation,
  useGetChangeReportMutation,
  useGetQuestionByIdMutation,
  useShowIdentificationFieldsMutation,
  useGetFerpaStatusMutation,
  useCreateAssignmentLinkMutation,
  useGetAssignmentVocabularyMutation,
  useGetAssignmentIsStartedMutation,
  useGetCollaboratorCountMutation,
  useCheckIsSelfAssignedMutation,
  useSetClassFiltersMutation,
  useIsAssignmentsExistMutation,
  useSetFilterCollapseMutation
} = assignApi;
